import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\VersionNote\GetVersionNoteListController::__invoke
* @see app/Http/Controllers/VersionNote/GetVersionNoteListController.php
* @route '/api/version-note'
*/
const GetVersionNoteListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetVersionNoteListController.url(options),
    method: 'get',
})

GetVersionNoteListController.definition = {
    methods: ["get","head"],
    url: '/api/version-note',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VersionNote\GetVersionNoteListController::__invoke
* @see app/Http/Controllers/VersionNote/GetVersionNoteListController.php
* @route '/api/version-note'
*/
GetVersionNoteListController.url = (options?: RouteQueryOptions) => {
    return GetVersionNoteListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VersionNote\GetVersionNoteListController::__invoke
* @see app/Http/Controllers/VersionNote/GetVersionNoteListController.php
* @route '/api/version-note'
*/
GetVersionNoteListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetVersionNoteListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VersionNote\GetVersionNoteListController::__invoke
* @see app/Http/Controllers/VersionNote/GetVersionNoteListController.php
* @route '/api/version-note'
*/
GetVersionNoteListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetVersionNoteListController.url(options),
    method: 'head',
})

export default GetVersionNoteListController